import { ACTIONS } from './paymentConstants';

export const setPayments = payments => {
  return {
    type: ACTIONS.SET_PAYMENTS,
    payments
  };
};
